import * as React from 'react';
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { URL, SECRET_TYPE } from '../../Config/appConfig';
import authDispatch from '../../ReduxRequests/Dispatch/authDispatch';
import authState from '../../ReduxRequests/State/authState';
import ErrorHandler from '../ErrorHandler/ErrorHandler';
import Clipboard from 'react-clipboard.js';
import Tooltip from '@material-ui/core/Tooltip';
import Footer from '../Footer/Footer';
import {Token, SecretDetails} from '../../Config/dataModel';
import '../../style/login.css';

const logo = require('../../resource/img/logo.svg');
const pageSpinner = require('../../resource/img/page-loading.gif');

interface SecretProps {
  resetSecret: (data: Token) => void,
  secretDetails: () => SecretDetails
}

interface SecretState {
  secretDetails: SecretDetails,
  openTooltip: boolean,
  loading: boolean
}

class Secret extends React.Component<RouteComponentProps & SecretProps, SecretState> {
  public constructor(props: SecretProps) {
    super(props);
    this.state = {
      secretDetails: null,
      openTooltip: false,
      loading: true
    };
    this.goToLogin = this.goToLogin.bind(this);
    this.clickTooltip = this.clickTooltip.bind(this);
    this.onError = this.onError.bind(this);
  }

  public componentDidMount() {
    this.props.resetSecret({token: this.props.history.location.pathname.split('/')[3]});
  }

  public componentWillReceiveProps(nextProps: SecretProps) {
    if (nextProps.secretDetails() !== this.props.secretDetails() && nextProps.secretDetails()) {
        this.setLoading(false);
        this.setState({
          secretDetails: nextProps.secretDetails()
        });
    }
  }

  public goToLogin(event: React.MouseEvent<HTMLElement>) {
    event.preventDefault();
    this.props.history.push(URL.LOGIN);
  }

  public clickTooltip() {
    const open = !this.state.openTooltip;
    this.setState({ 
      openTooltip: open
    });

    if (open) {
      window.setTimeout(() => {
        this.setState({
          openTooltip: false
        });
      }, 1000);
    }
  }

  public setLoading(loading: boolean) {
    this.setState({loading});
  }

  public onError() {
    this.setLoading(false);
  }

  public render() {
    const title = this.state.secretDetails ? SECRET_TYPE[this.state.secretDetails.type] : '';
    const replaceableText = title.toLowerCase() || '';

    return (
      <div>
        <div className="authContainer largeAuthContainer">
          <div className="cmCenter loginContainer">
            <button className="cmHorCenter" onClick={this.goToLogin}>
              <img src={logo} />
            </button>
            {this.state.loading ?
              <div className="authSpinnerContainer">
                <img className="cmCenter" src={pageSpinner}/>
              </div> :
              (this.state.secretDetails ?
                <div>
                  <div className="cmText loginLabel authLabel">API {title}</div>
                  <div>
                    <div className="cmText authInfoText">
                      The {replaceableText} below is provided for your use in setting up an API User. This {replaceableText} is provided only ONCE, please make sure to save the {replaceableText} in case any future changes are required, and to store in a safe place.
                      <br/><br/>
                      Please do not disclose this {replaceableText} to third parties. If you feel that your {replaceableText} is compromised in any way, you should immediately disable the API user and contact us at <a className="authEmail" href="mailto:support@cryptoblk.io">support@cryptoblk.io</a>.
                    </div>
                    <div className="cmInput authKey" onClick={this.clickTooltip}>
                      <Tooltip
                        PopperProps={{disablePortal: true}}
                        onClose={this.clickTooltip}
                        open={this.state.openTooltip}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                        title="Copied">
                        <Clipboard data-clipboard-text={this.state.secretDetails.secret}>{this.state.secretDetails.secret}</Clipboard>
                      </Tooltip>
                    </div>
                  </div>
                </div> : null)}
            <ErrorHandler onError={this.onError}/>
            <div className="cmBtnsContainer">
              <div className="cmHorCenter">
                <button className="cmBtn cmCenterBtn cmGreyBtn cmBoldText" onClick={this.goToLogin}>Close</button>
              </div>
            </div>
          </div>
        </div>
        <div className="authFooter"><Footer /></div>
      </div>
    );
  }
}

export default withRouter(connect(authState, authDispatch)(Secret));


// WEBPACK FOOTER //
// ./src/Components/Secret/Secret.tsx